import {useMemo, forwardRef} from 'react'
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './CustomInput.module.scss';
import React from 'react';

const cx = classnames.bind(styles);

const CustomInput = (props, ref) => {
  const {
    className,
    input,
    placeholder,
    meta = {},
    onClear,
    id,
  } = props;
  const isFailed = useMemo(() => {
    return meta.invalid && meta.touched
  }, [meta.invalid, meta.touched])

  const isSuccess = useMemo(() => {
    return meta.touched && !meta.invalid && !!input.value
  }, [meta.invalid, meta.touched])

  return (
    <div className={cx('root', {'error': isFailed, 'valid': isSuccess, 'clearable': !!onClear}, className)}>
      <input
        id={id}
        ref={ref}
        placeholder={placeholder}
        className={cx('input')}
        {...input}
      />
      {onClear && !!input?.value && (
        <button type="button" className={cx('clear-button', {'error': isFailed})} onClick={onClear}>
          <i className={cx('clear', 'icon-modal-close')}/>
        </button>
      )}
    </div>
  )
}

CustomInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onClear: PropTypes.func,
  meta: PropTypes.shape({
    invalid: PropTypes.bool,
    touched: PropTypes.bool
  })
}

export default forwardRef(CustomInput);
